import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { scheduledChannelSnapshotFrequencyTranslationMap } from 'dashboard/constants/scheduled-channel-snapshot-frequency-translation-map.constant';
import { BaseDataGridCellRenderer } from 'shared/abstract/base-data-grid-cell-renderer';

@Component({
    selector: 'app-scheduled-channel-snapshots-enabled-cell-renderer',
    templateUrl: './scheduled-channel-snapshots-enabled-cell-renderer.component.html',
    styleUrls: ['./scheduled-channel-snapshots-enabled-cell-renderer.component.scss'],
    imports: [TranslateModule],
})
export class ScheduledChannelSnapshotsEnabledCellRendererComponent extends BaseDataGridCellRenderer {
    public onDataChange(): any {}
}
